import { SHARED_THEME_COOKIE } from "./shared-theme-cookie";

/** Own key: the website's choice never changes the app's or the help center's theme. */
export const WEBSITE_THEME_STORAGE_KEY = "website-theme";

/**
 * Inline script: paints a scoped theme (help center, website) before first paint: shared cookie, else own storage, else light.
 * `data-scoped-theme` is ours alone; next-themes rewrites the class from the app theme until hydration.
 */
export function scopedThemeBootstrap(storageKey: string): string {
  return `(function(){try{var t="light";var m=/(?:^|; )${SHARED_THEME_COOKIE}=(dark|light)/.exec(document.cookie);if(m){t=m[1];}else{try{if(localStorage.getItem(${JSON.stringify(storageKey)})==="dark")t="dark";}catch(e){}}var h=document.documentElement;h.classList.remove(t==="dark"?"light":"dark");h.classList.add(t);h.style.colorScheme=t;h.setAttribute("data-scoped-theme",t);}catch(e){}})();`;
}

/** Light-only website pages: same attributes as {@link scopedThemeBootstrap}, stored choice ignored. */
export const SCOPED_LIGHT_THEME_BOOTSTRAP = `(function(){try{var h=document.documentElement;h.classList.remove("dark");h.classList.add("light");h.style.colorScheme="light";h.setAttribute("data-scoped-theme","light");}catch(e){}})();`;
